<template>
    <div>
        <div class="banner">
            <h2 class="mb-0">Making Trust a Priority</h2>
            <h1>Friendly Diamonds At Your Service</h1>
            <p>Our customers are the heart of our business. At Friendly Diamonds, we aim to go above & beyond to provide you the desired experience while shopping for your lab grown diamond jewelry.<br>These are the services that will help you count on us!</p>
            <!-- <NuxtLink :to="localePath('/contact-us')">contact us</NuxtLink> -->
        </div>
        <div class="container my-5 pt-4">
            <div class="row">
                <div class="col-md-4 col-12 mb-4">
                    <h3>Free Shipping</h3>
                    <p class="mb-0">Friendly Diamonds ensures a hassle-free & timely delivery of your order with the help of trusted delivery partners such as FedEx, UPS, and USPS. We offer free shipping worldwide and free return shipping on all return orders from the United States. </p>
                    <NuxtLink :to="localePath('/customer-service/shipping-policy')">read more</NuxtLink>
                </div>
                <div class="col-md-4 col-12 mb-4">
                    <h3>30 Day Returns</h3>
                    <p class="mb-0">We offer a 30-day, no questions asked return policy for a full refund on all orders delivered worldwide. You can also avail free return shipping on all items within 30 days of delivery of order across the United States. </p>
                    <NuxtLink :to="localePath('/customer-service/return-policy')"> read more </NuxtLink>
                </div>
                <div class="col-md-4 col-12 mb-4">
                    <h3>Lifetime Warranty </h3>
                    <p class="mb-0">Your Friendly Diamonds jewelry and <NuxtLink :to="localePath('/lab-diamonds')">lab diamonds</NuxtLink> are meant to last a lifetime. To ensure your complete satisfaction, we provide a free lifetime warranty against all manufacturing defects for our entire range of made-to-order and custom-made products. </p>
                    <NuxtLink :to="localePath('/customer-service/life-time-warranty')">read more </NuxtLink>
                </div>
                <div class="col-md-4 col-12 mb-4">
                    <h3>Free Ring Resizing</h3>
                    <p class="mb-0">If you ordered a wrong ring size or need different proportions within the first 12 months of purchase, Friendly Diamonds has you covered. You can avail a free one-time ring resizing within the first 12 months of your purchase.</p>
                    <NuxtLink :to="localePath('/customer-service/ring-resizing')">read more </NuxtLink>
                </div>
                <div class="col-md-4 col-12 mb-4">
                    <h3>Free Engraving</h3>
                    <p class="mb-0">Have a personal message to convey or a special date to remember? Get it engraved on your jewelry with Friendly Diamonds. We offer a free engraving service for all our made-to-order and <NuxtLink :to="localePath({ name:'cyo-setting-list-ring'})">custom-made rings</NuxtLink>.</p>
                    <NuxtLink :to="localePath('/customer-service/ring-engraving')">read more</NuxtLink>
                </div>
                <div class="col-md-4 col-12 mb-4">
                    <h3>Payment Options </h3>
                    <p class="mb-0">We offer multiple payment methods for purchasing your <NuxtLink :to="localePath('/fine-jewelry')">diamond jewelry</NuxtLink>. With us, you can complete your payment at once, split it with different cards, pay in fee-free monthly payments, or create saving plans for jewelry in advance with help of different avenues. </p>
                    <NuxtLink :to="localePath('/customer-service/payment-options')">read more </NuxtLink>
                </div>
                <div class="col-md-4 col-12 mb-4">
                    <h3>Book Appointments </h3>
                    <p class="mb-0">Our team has got you covered if you wish to dive deep into the world of diamonds! We offer a free one-on-one video consultation with our diamond and jewelry experts for all the queries that you may have related to lab diamonds or lab diamond jewelry.</p>
                    <NuxtLink :to="localePath('/appointment')">read more</NuxtLink>
                </div>
                <div class="col-md-4 col-12 mb-4">
                    <h3>Bespoke Custom Jewelry</h3>
                    <p class="mb-0">Are you looking to transform your own ideas into perfect custom-made jewelry pieces? With the help of Friendly Diamonds’ jewelry specialists and expert craftsmen, you can design your bespoke custom jewelry and bring your imagination to life.</p>
                    <NuxtLink :to="localePath('/customized-jewelry')">read more</NuxtLink>
                </div>
                <div class="col-md-4 col-12 mb-4">
                    <h3>Share Your Moments </h3>
                    <p class="mb-0">Nothing makes us happier than becoming a part of the special moments of our customers’ lives. We encourage you to Share Your Friendly Diamonds’ Moment with us and our team would love to offer a free <NuxtLink :to="localePath({ name: 'shop-solitaire-necklace'})">Diamond Solitaire Pendant</NuxtLink> as a memento!</p>
                    <NuxtLink :to="localePath('/testimonials')">read more</NuxtLink>
                </div>
                <div class="col-md-4 col-12 mb-4">
                    <h3>Lifetime Trade-In and Upgrade</h3>
                    <p class="mb-0">If you wish to trade-in your product for any reason, whether you've changed your preferences or simply seek something new, explore our Lifetime Trade-In and Upgrade Service, allowing for a smooth and more rewarding experience as you add to your collection.</p>
                    <NuxtLink :to="localePath('/customer-service/exchange-policy')">read more</NuxtLink>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
    const localePath = useLocalePath();
</script>

<style scoped>
.banner {
    background: #668b84;
    text-align: center;
    padding: 4%;
    color: #fff;
}

h1 {
    font-size: 48px;
    padding: 0.8%;
}
h2 {
    font-size: 16px;
}
h3 {
    font-size: 18px;
    font-weight: 600;
}
p a {
    font-weight: 400 !important;
    color: var(--green)!important;
    font-size: 16px !important;
}
.banner a {
    background: #fff;
    color: #000;
    text-transform: uppercase;
    font-weight: 600;
    font-size: 14px;
    display: inline-block;
    min-width: 250px;
    padding: 10px;
    margin-top: 1%;
    text-decoration: none;
}
a {
    color: var(--green);
    font-weight: 600;
    -webkit-text-decoration: underline;
    text-decoration: underline;
    font-size: 16px;
    display: inline-block;
    margin-bottom: 4px;
    text-transform: capitalize;
}
.get_in {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #f9fafb;
    padding: 2% 3%;
}

.get_text h4 {
    font-size: 20px;
    font-weight: 600;
}

.get_cta a {
    font-size: 14px;
    text-decoration: none;
    background: var(--green);
    color: #fff;
    padding: 7px 10px;
}
@media(max-width: 992px){
    h1 {
        font-size: 32px;
        padding: 0.8%;
    }
}
@media(max-width: 767px){
    .banner {
        padding: 15% 6%;
    }
    a{
        font-size: 14px;
    }

    p {
        font-size: 14px;
    }
    p a{
        font-size: 14px !important;
    }
    span {
        font-size: 14px;
    }
    .get_in{
        flex-wrap: wrap;
    }
    .get_in {
        display: flex;
        align-items: center;
        justify-content: space-between;
        background: #f9fafb;
        padding: 2% 3%;
    }
    .get_text h4 {
        font-size: 20px;
        font-weight: 600;
    }
    .get_cta a {
        font-size: 14px;
        text-decoration: none;
        background: var(--green);
        color: #fff;
        padding: 7px 10px;
    }
    .get_text {
        width: 100%;
        margin-bottom: 2%;
    }
    .get_text h4 {
        font-size: 16px;
    }
    .get_text p {
        font-size: 14px;
    }
}
</style>
